import React from 'react';
import { Panel } from './Panel.styles';
var PanelCmp = function (_a) {
    var mode = _a.mode, children = _a.children;
    return React.createElement(Panel, { mode: mode }, children);
};
export default PanelCmp;
